<template>
  <div>
    <el-container class="containerPc">
      <el-header>
        <div class="logo">
          <img src="../../assets/img/logo.png" alt="" width="25">
        </div>
        <p>心理咨询后台管理</p>
        <div class="rightHeader">
          <span class="time">{{ time.getFullYear() }}-{{ time.getMonth() + 1 }}-{{ time.getDate() }}, </span>
          <span class="username">{{ username }}</span>
          <el-dropdown @command="handleCommand">
            <el-avatar icon="el-icon-user-solid" size="medium" class="el-dropdown-link"></el-avatar>
            <el-dropdown-menu slot="dropdown" class="dropMenu">
              <el-dropdown-item command="logout">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-container class="content">
        <el-aside width="160px">
          <el-menu :default-active="url" class="el-menu-vertical-demo" router
                   text-color="#2A2D2E" unique-opened
                   active-text-color="#567CFF">
            <el-menu-item v-for="(obj,index) in  navBars" :key="index" :index="obj.path">
              <span slot="title">{{ obj.title }}</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-container>
          <el-main class="allow-select">
            <router-view class="sysIndexRef"></router-view>
          </el-main>
          <el-footer height="40px">
            <span>Copyright © {{ time.getFullYear() }} 亦笙信息 | 粤ICP备18110633号-1</span>
            <span style="cursor: pointer;color: cornflowerblue;margin-left: 10px" @click="toImg">反馈建议</span>
          </el-footer>
        </el-container>
      </el-container>
    </el-container>

    <el-dialog title="信息" :visible.sync="imgDialog" width="80%" top="0">
      <div class="img-contain" @mousedown="kd($event)" @mouseup="kp($event)" @mousemove="km($event)">
        <img :src="imgUrl" style="width: 100%" draggable="false"/>
        <div v-for="(item,index) in marks" :key="index" class="mark"
             :style="'top:'+item.y+'px;left:'+item.x+'px;width:'+item.w+'px;height:'+item.h+'px'"></div>
        <div class="mark"
             :style="'top:'+tempPoint.y+'px;left:'+tempPoint.x+'px;width:'+tempPoint.w+'px;height:'+tempPoint.h+'px'"></div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import base from '@/api/common'
import adminMenu from '@/api/admin_menu_permission'
import domToImage from 'dom-to-image';

export default {
  name: "sysIndex",
  data() {
    return {
      username: 'user',
      time: new Date(),
      navBars: [],
      url: this.$route.path,

      imgDialog: false,
      imgUrl: '',
      me: {
        md: false,
        mp: false,
      },
      point: {
        s: {x: 0, y: 0, w: 10, h: 10},
        e: {x: 0, y: 0, w: 10, h: 10}
      },
      marks: [],
      tempPoint: {x: 0, y: 0, w: 0, h: 0},
    }
  },
  methods: {
    handleCommand(command) {
      if (command == "logout") {
        let token = localStorage.access_token || '';
        this.$ajax.get(base.api.logout + "?token=" + token).then((res) => {
          if (res.data.status == 'success') {
            this.unLogin = true;
            localStorage.clear();
            this.$router.push('/admin/login');
          }
        })
      }
    },
    toImg() {
      let app = $('#app')[0];
      let that = this;
      domToImage.toPng(app, {}).then(url => {
        that.imgUrl = url;
        that.marks.length = 0; // 清空标记
        that.imgDialog = true;
      });
    },
    kd(e) {
      this.point.s.x = e.offsetX;
      this.point.s.y = e.offsetY;
      this.me.md = true;
    },
    km(e) {
      let ex = e.offsetX;
      let ey = e.offsetY;
      this.point.e.x = ex;
      this.point.e.y = ey;
      if (!this.me.md) {
        return;
      }
      this.tempPoint = this.calcPoint();
    },
    kp() {
      this.me.md = false;
      // 计算拖动图框大小
      this.marks.push(this.calcPoint(1));
      this.tempPoint = {x: 0, y: 0, w: 0, h: 0};
    },
    calcPoint() {
      let sx = this.point.s.x;
      let sy = this.point.s.y;

      let ex = this.point.e.x;
      let ey = this.point.e.y;

      let w = ex - sx;
      let h = ey - sy;
      let point = {
        w: Math.abs(w),
        h: Math.abs(h),
        x: 0,
        y: 0
      };
      if (h >= 0) {
        point.y = sy;
      } else {
        point.y = ey;
      }
      if (w >= 0) {
        point.x = sx;
      } else {
        point.x = ex;
      }
      return point;
    }
  },
  async mounted() {
    document.onselectstart = null;
    let a = this.url.split('/')[2]
    if (a == 'doctor' || a == 'page' || a == 'recommend' || a == 'chatServer' || a == 'consultationManage' || a == 'lectureManage' || a == 'drug' || a == 'indication' || a == 'city' || a == 'user' || a == 'exam' || a == 'event' || a == 'dict' || a == 'index' || a == 'auth' || a == 'appoint' || a == 'role' || a == 'message') {
      this.url = this.$route.path
    } else {
      this.url = this.$route.meta.parentPath
    }
    // 账户信息
    let user = await base.utils.getCurrent();
    if (user != null && user.type == 3) {
      this.username = user.account;
      localStorage.setItem('curAccount', user.account);
      localStorage.setItem('curUid', user.id);
      // 获取权限动态分配菜单
      let permissions = await this.$ajax.post(base.manager_api.auth.permissions_me).then(res => {
        if (res.data.status === 'success') {
          return res.data.list;
        } else {
          return [];
        }
      });
      this.navBars = adminMenu.getMenuByPermissions(permissions);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/admin.scss';

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.img-contain {
  width: 100%;
  border: 1px solid #8c8c8c;
  background-size: 100%;
  position: relative;
  opacity: 0.99;
  /* Chrome all / Safari all /opera15+*/
  -webkit-user-select: none;
  /* Firefox all */
  -moz-user-select: none;
  /* IE 10+ */
  -ms-user-select: none;
  /* 通用 */
  user-select: none;

  img {
    position: relative;
    z-index: -99;

  }

  .mark {
    position: absolute;
    z-index: -1;
    border: 1px solid red;
  }

}
</style>
